import cn from "@/utils/cn"
import { ComponentPropsWithoutRef } from "react"

type InputLabelProps = ComponentPropsWithoutRef<"label">

const InputLabel = ({
  className,
  children,
  ...otherProps
}: InputLabelProps) => (
  <label
    className={cn(
      "font-semibold leading-6 tracking-wide text-primary/90",
      className
    )}
    {...otherProps}
  >
    {children}
  </label>
)

export default InputLabel
